import type { Abi } from "viem";

// Generated by scripts/generate-evm-abis.ts. Do not edit by hand.

export const erc20Abi = [
    {
        "type": "function",
        "name": "allowance",
        "inputs": [
            {
                "name": "owner",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "spender",
                "type": "address",
                "internalType": "address"
            }
        ],
        "outputs": [
            {
                "name": "",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "approve",
        "inputs": [
            {
                "name": "spender",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "value",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [
            {
                "name": "",
                "type": "bool",
                "internalType": "bool"
            }
        ],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "balanceOf",
        "inputs": [
            {
                "name": "account",
                "type": "address",
                "internalType": "address"
            }
        ],
        "outputs": [
            {
                "name": "",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "decimals",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "uint8",
                "internalType": "uint8"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "name",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "string",
                "internalType": "string"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "symbol",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "string",
                "internalType": "string"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "totalSupply",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "transfer",
        "inputs": [
            {
                "name": "to",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "value",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [
            {
                "name": "",
                "type": "bool",
                "internalType": "bool"
            }
        ],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "transferFrom",
        "inputs": [
            {
                "name": "from",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "to",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "value",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [
            {
                "name": "",
                "type": "bool",
                "internalType": "bool"
            }
        ],
        "stateMutability": "nonpayable"
    },
    {
        "type": "event",
        "name": "Approval",
        "inputs": [
            {
                "name": "owner",
                "type": "address",
                "indexed": true,
                "internalType": "address"
            },
            {
                "name": "spender",
                "type": "address",
                "indexed": true,
                "internalType": "address"
            },
            {
                "name": "value",
                "type": "uint256",
                "indexed": false,
                "internalType": "uint256"
            }
        ],
        "anonymous": false
    },
    {
        "type": "event",
        "name": "Transfer",
        "inputs": [
            {
                "name": "from",
                "type": "address",
                "indexed": true,
                "internalType": "address"
            },
            {
                "name": "to",
                "type": "address",
                "indexed": true,
                "internalType": "address"
            },
            {
                "name": "value",
                "type": "uint256",
                "indexed": false,
                "internalType": "uint256"
            }
        ],
        "anonymous": false
    },
    {
        "type": "error",
        "name": "ERC20InsufficientAllowance",
        "inputs": [
            {
                "name": "spender",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "allowance",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "needed",
                "type": "uint256",
                "internalType": "uint256"
            }
        ]
    },
    {
        "type": "error",
        "name": "ERC20InsufficientBalance",
        "inputs": [
            {
                "name": "sender",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "balance",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "needed",
                "type": "uint256",
                "internalType": "uint256"
            }
        ]
    },
    {
        "type": "error",
        "name": "ERC20InvalidApprover",
        "inputs": [
            {
                "name": "approver",
                "type": "address",
                "internalType": "address"
            }
        ]
    },
    {
        "type": "error",
        "name": "ERC20InvalidReceiver",
        "inputs": [
            {
                "name": "receiver",
                "type": "address",
                "internalType": "address"
            }
        ]
    },
    {
        "type": "error",
        "name": "ERC20InvalidSender",
        "inputs": [
            {
                "name": "sender",
                "type": "address",
                "internalType": "address"
            }
        ]
    },
    {
        "type": "error",
        "name": "ERC20InvalidSpender",
        "inputs": [
            {
                "name": "spender",
                "type": "address",
                "internalType": "address"
            }
        ]
    }
] as const satisfies Abi;

export const etherSwapAbi = [
    {
        "type": "function",
        "name": "DOMAIN_SEPARATOR",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_CLAIM",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_COMMIT",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_REFUND",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "VERSION",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "uint8",
                "internalType": "uint8"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "checkCommitmentSignature",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [
            {
                "name": "",
                "type": "bool",
                "internalType": "bool"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "claim",
        "inputs": [
            {
                "name": "preimage",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [
            {
                "name": "",
                "type": "address",
                "internalType": "address"
            }
        ],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claim",
        "inputs": [
            {
                "name": "preimage",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claim",
        "inputs": [
            {
                "name": "preimage",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claim",
        "inputs": [
            {
                "name": "preimage",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claimBatch",
        "inputs": [
            {
                "name": "preimages",
                "type": "bytes32[]",
                "internalType": "bytes32[]"
            },
            {
                "name": "amounts",
                "type": "uint256[]",
                "internalType": "uint256[]"
            },
            {
                "name": "refundAddresses",
                "type": "address[]",
                "internalType": "address[]"
            },
            {
                "name": "timelocks",
                "type": "uint256[]",
                "internalType": "uint256[]"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claimBatch",
        "inputs": [
            {
                "name": "entries",
                "type": "tuple[]",
                "internalType": "struct EtherSwap.BatchClaimEntry[]",
                "components": [
                    {
                        "name": "preimage",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "amount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "timelock",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "hashValues",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [
            {
                "name": "result",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "pure"
    },
    {
        "type": "function",
        "name": "lock",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "payable"
    },
    {
        "type": "function",
        "name": "lock",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "payable"
    },
    {
        "type": "function",
        "name": "lockPrepayMinerfee",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address payable"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "prepayAmount",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "payable"
    },
    {
        "type": "function",
        "name": "refund",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "refund",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "refundCooperative",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "refundCooperative",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "swaps",
        "inputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [
            {
                "name": "",
                "type": "bool",
                "internalType": "bool"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "version",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "uint8",
                "internalType": "uint8"
            }
        ],
        "stateMutability": "pure"
    },
    {
        "type": "event",
        "name": "Claim",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "indexed": true,
                "internalType": "bytes32"
            },
            {
                "name": "preimage",
                "type": "bytes32",
                "indexed": false,
                "internalType": "bytes32"
            }
        ],
        "anonymous": false
    },
    {
        "type": "event",
        "name": "Lockup",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "indexed": true,
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "indexed": false,
                "internalType": "uint256"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "indexed": true,
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "indexed": true,
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "indexed": false,
                "internalType": "uint256"
            }
        ],
        "anonymous": false
    },
    {
        "type": "event",
        "name": "Refund",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "indexed": true,
                "internalType": "bytes32"
            }
        ],
        "anonymous": false
    },
    {
        "type": "error",
        "name": "CommitmentCannotBeClaimedAsSwap",
        "inputs": []
    },
    {
        "type": "error",
        "name": "EtherTransferFailed",
        "inputs": []
    },
    {
        "type": "error",
        "name": "InvalidPrepayAmount",
        "inputs": []
    },
    {
        "type": "error",
        "name": "InvalidSignature",
        "inputs": []
    },
    {
        "type": "error",
        "name": "SwapAlreadyExists",
        "inputs": []
    },
    {
        "type": "error",
        "name": "SwapNotFound",
        "inputs": []
    },
    {
        "type": "error",
        "name": "SwapNotTimedOut",
        "inputs": []
    },
    {
        "type": "error",
        "name": "ZeroAmount",
        "inputs": []
    }
] as const satisfies Abi;

export const erc20SwapAbi = [
    {
        "type": "function",
        "name": "DOMAIN_SEPARATOR",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_CLAIM",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_COMMIT",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_REFUND",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "VERSION",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "uint8",
                "internalType": "uint8"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "checkCommitmentSignature",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [
            {
                "name": "",
                "type": "bool",
                "internalType": "bool"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "claim",
        "inputs": [
            {
                "name": "preimage",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claim",
        "inputs": [
            {
                "name": "preimage",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [
            {
                "name": "",
                "type": "address",
                "internalType": "address"
            }
        ],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claim",
        "inputs": [
            {
                "name": "preimage",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claim",
        "inputs": [
            {
                "name": "preimage",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claimBatch",
        "inputs": [
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "entries",
                "type": "tuple[]",
                "internalType": "struct ERC20Swap.BatchClaimEntry[]",
                "components": [
                    {
                        "name": "preimage",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "amount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "timelock",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claimBatch",
        "inputs": [
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "preimages",
                "type": "bytes32[]",
                "internalType": "bytes32[]"
            },
            {
                "name": "amounts",
                "type": "uint256[]",
                "internalType": "uint256[]"
            },
            {
                "name": "refundAddresses",
                "type": "address[]",
                "internalType": "address[]"
            },
            {
                "name": "timelocks",
                "type": "uint256[]",
                "internalType": "uint256[]"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "hashValues",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [
            {
                "name": "result",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "pure"
    },
    {
        "type": "function",
        "name": "lock",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "lock",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "lockPrepayMinerfee",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address payable"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "payable"
    },
    {
        "type": "function",
        "name": "refund",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "refund",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "refundCooperative",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "refundCooperative",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "swaps",
        "inputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [
            {
                "name": "",
                "type": "bool",
                "internalType": "bool"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "version",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "uint8",
                "internalType": "uint8"
            }
        ],
        "stateMutability": "pure"
    },
    {
        "type": "event",
        "name": "Claim",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "indexed": true,
                "internalType": "bytes32"
            },
            {
                "name": "preimage",
                "type": "bytes32",
                "indexed": false,
                "internalType": "bytes32"
            }
        ],
        "anonymous": false
    },
    {
        "type": "event",
        "name": "Lockup",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "indexed": true,
                "internalType": "bytes32"
            },
            {
                "name": "amount",
                "type": "uint256",
                "indexed": false,
                "internalType": "uint256"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "indexed": false,
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "indexed": true,
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "indexed": true,
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "indexed": false,
                "internalType": "uint256"
            }
        ],
        "anonymous": false
    },
    {
        "type": "event",
        "name": "Refund",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "indexed": true,
                "internalType": "bytes32"
            }
        ],
        "anonymous": false
    },
    {
        "type": "error",
        "name": "CommitmentCannotBeClaimedAsSwap",
        "inputs": []
    },
    {
        "type": "error",
        "name": "EtherTransferFailed",
        "inputs": []
    },
    {
        "type": "error",
        "name": "InvalidSignature",
        "inputs": []
    },
    {
        "type": "error",
        "name": "SwapAlreadyExists",
        "inputs": []
    },
    {
        "type": "error",
        "name": "SwapNotFound",
        "inputs": []
    },
    {
        "type": "error",
        "name": "SwapNotTimedOut",
        "inputs": []
    },
    {
        "type": "error",
        "name": "TokenTransferFailed",
        "inputs": []
    },
    {
        "type": "error",
        "name": "TokenTransferFromFailed",
        "inputs": []
    },
    {
        "type": "error",
        "name": "ZeroAmount",
        "inputs": []
    }
] as const satisfies Abi;

export const routerAbi = [
    {
        "type": "constructor",
        "inputs": [
            {
                "name": "swapContract",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "erc20SwapContract",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "permit2Contract",
                "type": "address",
                "internalType": "address"
            }
        ],
        "stateMutability": "nonpayable"
    },
    {
        "type": "receive",
        "stateMutability": "payable"
    },
    {
        "type": "function",
        "name": "DOMAIN_SEPARATOR",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "ERC20_SWAP_CONTRACT",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "address",
                "internalType": "contract ERC20Swap"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "PERMIT2",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "address",
                "internalType": "contract ISignatureTransfer"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "SWAP_CONTRACT",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "address",
                "internalType": "contract EtherSwap"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_CCTP_DATA",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_CLAIM",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_CLAIM_CALL",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_CLAIM_CCTP",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_CLAIM_SEND",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_EXECUTE_LOCK_ERC20",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPEHASH_SEND_DATA",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "TYPESTRING_EXECUTE_LOCK_ERC20",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "string",
                "internalType": "string"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "VERSION",
        "inputs": [],
        "outputs": [
            {
                "name": "",
                "type": "uint8",
                "internalType": "uint8"
            }
        ],
        "stateMutability": "view"
    },
    {
        "type": "function",
        "name": "claimCall",
        "inputs": [
            {
                "name": "claim",
                "type": "tuple",
                "internalType": "struct Router.Claim",
                "components": [
                    {
                        "name": "preimage",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "amount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "timelock",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            },
            {
                "name": "callee",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "callData",
                "type": "bytes",
                "internalType": "bytes"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claimCall",
        "inputs": [
            {
                "name": "claim",
                "type": "tuple",
                "internalType": "struct Router.Claim",
                "components": [
                    {
                        "name": "preimage",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "amount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "timelock",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            },
            {
                "name": "callee",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "callData",
                "type": "bytes",
                "internalType": "bytes"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claimERC20Call",
        "inputs": [
            {
                "name": "claim",
                "type": "tuple",
                "internalType": "struct Router.Erc20Claim",
                "components": [
                    {
                        "name": "preimage",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "amount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "tokenAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "timelock",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            },
            {
                "name": "callee",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "callData",
                "type": "bytes",
                "internalType": "bytes"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claimERC20Call",
        "inputs": [
            {
                "name": "claim",
                "type": "tuple",
                "internalType": "struct Router.Erc20Claim",
                "components": [
                    {
                        "name": "preimage",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "amount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "tokenAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "timelock",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            },
            {
                "name": "callee",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "callData",
                "type": "bytes",
                "internalType": "bytes"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claimERC20Execute",
        "inputs": [
            {
                "name": "claim",
                "type": "tuple",
                "internalType": "struct Router.Erc20Claim",
                "components": [
                    {
                        "name": "preimage",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "amount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "tokenAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "timelock",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            },
            {
                "name": "calls",
                "type": "tuple[]",
                "internalType": "struct Router.Call[]",
                "components": [
                    {
                        "name": "target",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "value",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "callData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "token",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "minAmountOut",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "destination",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claimERC20Execute",
        "inputs": [
            {
                "name": "claim",
                "type": "tuple",
                "internalType": "struct Router.Erc20Claim",
                "components": [
                    {
                        "name": "preimage",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "amount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "tokenAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "timelock",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            },
            {
                "name": "calls",
                "type": "tuple[]",
                "internalType": "struct Router.Call[]",
                "components": [
                    {
                        "name": "target",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "value",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "callData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "token",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "minAmountOut",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claimERC20ExecuteCctp",
        "inputs": [
            {
                "name": "claim",
                "type": "tuple",
                "internalType": "struct Router.Erc20Claim",
                "components": [
                    {
                        "name": "preimage",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "amount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "tokenAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "timelock",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            },
            {
                "name": "calls",
                "type": "tuple[]",
                "internalType": "struct Router.Call[]",
                "components": [
                    {
                        "name": "target",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "value",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "callData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "token",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "tokenMessenger",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "cctpData",
                "type": "tuple",
                "internalType": "struct Router.CctpData",
                "components": [
                    {
                        "name": "destinationDomain",
                        "type": "uint32",
                        "internalType": "uint32"
                    },
                    {
                        "name": "mintRecipient",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "destinationCaller",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "maxFee",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "minFinalityThreshold",
                        "type": "uint32",
                        "internalType": "uint32"
                    },
                    {
                        "name": "hookData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "auth",
                "type": "tuple",
                "internalType": "struct Router.ClaimCctpAuthorization",
                "components": [
                    {
                        "name": "minAmount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            }
        ],
        "outputs": [],
        "stateMutability": "payable"
    },
    {
        "type": "function",
        "name": "claimERC20ExecuteOft",
        "inputs": [
            {
                "name": "claim",
                "type": "tuple",
                "internalType": "struct Router.Erc20Claim",
                "components": [
                    {
                        "name": "preimage",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "amount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "tokenAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "timelock",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            },
            {
                "name": "calls",
                "type": "tuple[]",
                "internalType": "struct Router.Call[]",
                "components": [
                    {
                        "name": "target",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "value",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "callData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "token",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "oft",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "sendData",
                "type": "tuple",
                "internalType": "struct Router.SendData",
                "components": [
                    {
                        "name": "dstEid",
                        "type": "uint32",
                        "internalType": "uint32"
                    },
                    {
                        "name": "to",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "extraOptions",
                        "type": "bytes",
                        "internalType": "bytes"
                    },
                    {
                        "name": "composeMsg",
                        "type": "bytes",
                        "internalType": "bytes"
                    },
                    {
                        "name": "oftCmd",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "auth",
                "type": "tuple",
                "internalType": "struct Router.ClaimSendAuthorization",
                "components": [
                    {
                        "name": "minAmountLd",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "lzTokenFee",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            }
        ],
        "outputs": [],
        "stateMutability": "payable"
    },
    {
        "type": "function",
        "name": "claimExecute",
        "inputs": [
            {
                "name": "claim",
                "type": "tuple",
                "internalType": "struct Router.Claim",
                "components": [
                    {
                        "name": "preimage",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "amount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "timelock",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            },
            {
                "name": "calls",
                "type": "tuple[]",
                "internalType": "struct Router.Call[]",
                "components": [
                    {
                        "name": "target",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "value",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "callData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "token",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "minAmountOut",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "claimExecute",
        "inputs": [
            {
                "name": "claim",
                "type": "tuple",
                "internalType": "struct Router.Claim",
                "components": [
                    {
                        "name": "preimage",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "amount",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "refundAddress",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "timelock",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "v",
                        "type": "uint8",
                        "internalType": "uint8"
                    },
                    {
                        "name": "r",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "s",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    }
                ]
            },
            {
                "name": "calls",
                "type": "tuple[]",
                "internalType": "struct Router.Call[]",
                "components": [
                    {
                        "name": "target",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "value",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "callData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "token",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "minAmountOut",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "destination",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "v",
                "type": "uint8",
                "internalType": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32",
                "internalType": "bytes32"
            }
        ],
        "outputs": [],
        "stateMutability": "nonpayable"
    },
    {
        "type": "function",
        "name": "executeAndLock",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "calls",
                "type": "tuple[]",
                "internalType": "struct Router.Call[]",
                "components": [
                    {
                        "name": "target",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "value",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "callData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            }
        ],
        "outputs": [],
        "stateMutability": "payable"
    },
    {
        "type": "function",
        "name": "executeAndLockERC20",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "calls",
                "type": "tuple[]",
                "internalType": "struct Router.Call[]",
                "components": [
                    {
                        "name": "target",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "value",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "callData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            }
        ],
        "outputs": [],
        "stateMutability": "payable"
    },
    {
        "type": "function",
        "name": "executeAndLockERC20WithPermit2",
        "inputs": [
            {
                "name": "preimageHash",
                "type": "bytes32",
                "internalType": "bytes32"
            },
            {
                "name": "tokenAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "claimAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "timelock",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "calls",
                "type": "tuple[]",
                "internalType": "struct Router.Call[]",
                "components": [
                    {
                        "name": "target",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "value",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "callData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "permit",
                "type": "tuple",
                "internalType": "struct ISignatureTransfer.PermitTransferFrom",
                "components": [
                    {
                        "name": "permitted",
                        "type": "tuple",
                        "internalType": "struct ISignatureTransfer.TokenPermissions",
                        "components": [
                            {
                                "name": "token",
                                "type": "address",
                                "internalType": "address"
                            },
                            {
                                "name": "amount",
                                "type": "uint256",
                                "internalType": "uint256"
                            }
                        ]
                    },
                    {
                        "name": "nonce",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "deadline",
                        "type": "uint256",
                        "internalType": "uint256"
                    }
                ]
            },
            {
                "name": "owner",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "signature",
                "type": "bytes",
                "internalType": "bytes"
            }
        ],
        "outputs": [],
        "stateMutability": "payable"
    },
    {
        "type": "function",
        "name": "executeCctp",
        "inputs": [
            {
                "name": "calls",
                "type": "tuple[]",
                "internalType": "struct Router.Call[]",
                "components": [
                    {
                        "name": "target",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "value",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "callData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "token",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "tokenMessenger",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "cctpData",
                "type": "tuple",
                "internalType": "struct Router.CctpData",
                "components": [
                    {
                        "name": "destinationDomain",
                        "type": "uint32",
                        "internalType": "uint32"
                    },
                    {
                        "name": "mintRecipient",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "destinationCaller",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "maxFee",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "minFinalityThreshold",
                        "type": "uint32",
                        "internalType": "uint32"
                    },
                    {
                        "name": "hookData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "minAmount",
                "type": "uint256",
                "internalType": "uint256"
            }
        ],
        "outputs": [],
        "stateMutability": "payable"
    },
    {
        "type": "function",
        "name": "executeOft",
        "inputs": [
            {
                "name": "calls",
                "type": "tuple[]",
                "internalType": "struct Router.Call[]",
                "components": [
                    {
                        "name": "target",
                        "type": "address",
                        "internalType": "address"
                    },
                    {
                        "name": "value",
                        "type": "uint256",
                        "internalType": "uint256"
                    },
                    {
                        "name": "callData",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "token",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "oft",
                "type": "address",
                "internalType": "address"
            },
            {
                "name": "sendData",
                "type": "tuple",
                "internalType": "struct Router.SendData",
                "components": [
                    {
                        "name": "dstEid",
                        "type": "uint32",
                        "internalType": "uint32"
                    },
                    {
                        "name": "to",
                        "type": "bytes32",
                        "internalType": "bytes32"
                    },
                    {
                        "name": "extraOptions",
                        "type": "bytes",
                        "internalType": "bytes"
                    },
                    {
                        "name": "composeMsg",
                        "type": "bytes",
                        "internalType": "bytes"
                    },
                    {
                        "name": "oftCmd",
                        "type": "bytes",
                        "internalType": "bytes"
                    }
                ]
            },
            {
                "name": "minAmountLd",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "lzTokenFee",
                "type": "uint256",
                "internalType": "uint256"
            },
            {
                "name": "refundAddress",
                "type": "address",
                "internalType": "address"
            }
        ],
        "outputs": [],
        "stateMutability": "payable"
    },
    {
        "type": "error",
        "name": "CallFailed",
        "inputs": [
            {
                "name": "index",
                "type": "uint256",
                "internalType": "uint256"
            }
        ]
    },
    {
        "type": "error",
        "name": "ClaimInvalidAddress",
        "inputs": []
    },
    {
        "type": "error",
        "name": "EtherTransferFailed",
        "inputs": []
    },
    {
        "type": "error",
        "name": "InsufficientBalance",
        "inputs": []
    },
    {
        "type": "error",
        "name": "ReentrancyGuardReentrantCall",
        "inputs": []
    },
    {
        "type": "error",
        "name": "SafeERC20FailedOperation",
        "inputs": [
            {
                "name": "token",
                "type": "address",
                "internalType": "address"
            }
        ]
    },
    {
        "type": "error",
        "name": "SwapCallNotAllowed",
        "inputs": []
    },
    {
        "type": "error",
        "name": "TokenTransferFailed",
        "inputs": []
    }
] as const satisfies Abi;
